if (!customElements.get('peddon-promo-code')) {
  class PeddonPromoCode extends HTMLElement {
    connectedCallback() {
      this.code = this.dataset.code;
      this.checked = false;
      this.appliedToCart = false;
      this.checkbox = this.querySelector('[data-promo-checkbox]');
      this.copyButton = this.querySelector('[data-promo-copy]');

      this.checkbox.addEventListener('click', event => {
        event.preventDefault();
        event.stopPropagation();
        this.checked ? this.uncheck() : this.check();
      });

      this.checkbox.addEventListener('keydown', event => {
        if (event.key !== ' ' && event.key !== 'Enter') return;
        event.preventDefault();
        this.checked ? this.uncheck() : this.check();
      });

      this.querySelector('.w__DiscountWrap').addEventListener('click', () => {
        if (!this.checked) this.check();
      });

      this.copyButton.addEventListener('click', () => this.copy());
    }

    get priceElement() {
      return document.getElementById(`Product-Price-${this.dataset.sectionId}`);
    }

    check() {
      this.checked = true;
      this.setCheckboxState();
      this.priceElement?.classList.add('peddon-promo--applied');
      this.applyToCart();
    }

    uncheck() {
      this.checked = false;
      this.setCheckboxState();
      this.priceElement?.classList.remove('peddon-promo--applied');
    }

    setCheckboxState() {
      this.checkbox.classList.toggle('checked', this.checked);
      this.checkbox.classList.toggle('unchecked', !this.checked);
      this.checkbox.setAttribute('aria-checked', this.checked);
    }

    copy() {
      navigator.clipboard
        .writeText(this.code)
        .then(() => {
          this.copyButton.textContent = 'Kopyalandı';
          this.copyButton.classList.add('is-copied');
          setTimeout(() => {
            this.copyButton.textContent = 'Kodu Kopyala';
            this.copyButton.classList.remove('is-copied');
          }, 3000);
        })
        .catch(error => console.error('[Peddon Promo] Kopyalanamadı:', error));
    }

    // Kodu oturuma yazar (checkout'ta otomatik uygulanır); sepet doluysa mevcut kodlarla birlikte sepete de ekler.
    applyToCart() {
      if (this.appliedToCart) return;
      this.appliedToCart = true;

      const root = window.Shopify?.routes?.root || '/';
      const code = encodeURIComponent(this.code);

      fetch(`${root}discount/${code}`)
        .then(() => fetch(`${root}cart.js`))
        .then(response => response.json())
        .then(cart => {
          if (!cart.item_count) return;

          const codes = (cart.discount_codes || []).map(discount => discount.code);
          if (!codes.includes(this.code)) codes.push(this.code);

          return fetch(`${root}cart/update.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ discount: codes.join(',') })
          });
        })
        .catch(error => console.error('[Peddon Promo] Kod uygulanamadı:', error));
    }
  }

  customElements.define('peddon-promo-code', PeddonPromoCode);
}
